import { render } from "./RecepcionView.vue?vue&type=template&id=2ea42212&ts=true"
import script from "./RecepcionView.vue?vue&type=script&lang=ts"
export * from "./RecepcionView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__